import { SubscriptionTypes } from 'WebSocket/CacheManager/SubscriptionTypes';
import { Id } from 'NSwag/ServerClient/Client.nswag';
import Util from 'Util/index';

/*
 * A base class for all the WebSocket handlers.
 */
export abstract class BaseHandler<TData> {
    /**
     * The type of data this Handler will be receiving.
     */
    abstract subscriptionType: SubscriptionTypes;

    /**
     * The type of object that each handler recieves concrete instances of.
     */
    abstract type?: { new(...args: any[]): TData };

    /**
     * Takes the given generic message data object(s) and re-initializes them
     * with the correct class type.
     * @param data - The received data array.
     */
    rehydratePrototypes = (data: Array<Record<string, any>>): Array<TData> | null => {
        const rehydratedData = new Array<TData>();
        if (this.type == null) {
            return null;
        } else {
            for (const datum of data) {
                const rehydratedDatum = Util.hydrate<TData>(this.type, datum);
                rehydratedData.push(rehydratedDatum);
            }

            return rehydratedData;
        }
    }

    /**
     * A function that adds a received message data object(s) to the current CacheManager.
     * @param data - The received data array.
     */
    abstract handleAdd: (data: TData[]) => void;

    /**
     * A function that modifies current Cache objects in the CacheManager with new ones.
     * @param data - The received data array.
     */
    abstract handleModify: (data: TData[]) => void;

    /**
     * A function that deletes the current objects in cache marked with these Id(s).
     * @param data - The received data array.
     */
    abstract handleDelete: (data: Id[]) => void;
}